import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Briefcase, FileText, Mail, Users, Newspaper, Tag, CreditCard, Settings, LogOut, ExternalLink, Quote } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/inquiries", label: "Business Inquiries", icon: Briefcase },
  { to: "/admin/intakes", label: "Career Intakes", icon: FileText },
  { to: "/admin/contacts", label: "Contacts", icon: Mail },
  { to: "/admin/newsletter", label: "Newsletter", icon: Users },
  { to: "/admin/blog", label: "Blog", icon: Newspaper },
  { to: "/admin/testimonials", label: "Testimonials", icon: Quote },
  { to: "/admin/pricing", label: "Pricing", icon: Tag },
  { to: "/admin/payments", label: "Payments", icon: CreditCard },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => { await logout(); navigate("/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-ivory flex" data-testid="admin-layout">
      <aside className="w-64 bg-espresso text-ivory flex-col hidden md:flex fixed h-screen">
        <Link to="/" className="font-serif text-xl px-6 py-6 border-b border-ivory/10">people, redefined.</Link>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-champagne text-espresso" : "text-ivory/75 hover:bg-ivory/10"}`}>
              <l.icon size={18} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-4 border-t border-ivory/10 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-ivory/75 hover:bg-ivory/10 transition-colors"><ExternalLink size={18} /> View Site</a>
          <button onClick={doLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-ivory/75 hover:bg-ivory/10 transition-colors"><LogOut size={18} /> Sign Out</button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="md:hidden fixed top-0 w-full bg-espresso text-ivory z-40 flex items-center justify-between px-4 py-3">
        <Link to="/admin" className="font-serif text-lg">people, redefined.</Link>
        <button onClick={doLogout} className="text-ivory/80"><LogOut size={20} /></button>
      </div>

      <main className="flex-1 md:ml-64 p-6 lg:p-10 pt-20 md:pt-10">
        <div className="md:hidden flex gap-2 overflow-x-auto pb-4 mb-4 border-b border-champagne/20">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `whitespace-nowrap text-xs px-3 py-2 rounded-full ${isActive ? "bg-espresso text-ivory" : "bg-taupe text-espresso"}`}>{l.label}</NavLink>
          ))}
        </div>
        <Outlet />
      </main>
    </div>
  );
}
